import React from "react";
import "./Banner.css";
import Typical from 'react-typical'
import myImage from '../../../images/banner-img.png'

const Banner = () => {

  return (
    <div className="banner">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <div className="row g-5 my-5 px-5 d-flex align-items-center justify-content-center">
        <div className="col-md-7 text-start">
          <h3>Hello,</h3>
          <h1 className="text-white" style={{ fontSize: "4em" }}>I'm <span className="text-warning">Tanmoy Parvez</span></h1>

          <h3 className="text-white">
            <Typical
              loop={Infinity}
              wrapper="p"
              steps={[
                'Mern Stack Developer',
                1000,
                'Frontend Developer',
                1000,
                'JavaScript Developer',
                1000,
                'React Developer',
                1000,
              ]}
            />
          </h3>
          <button className="btn btn-warning rounded-pill px-3 mt-2">
            <a href="https://drive.google.com/file/d/13PXriCopfEbqtkEx__jzfPBBr_akrHBr/view?usp=sharing" target="-blank" style={{ textDecoration: "none", color: "black" }}>Download Resume</a>
          </button>
        </div>
        <div className="col-md-5">
          <img src={myImage} alt="" className="w-100 p-3" />
        </div>
      </div>
      <hr style={{ color: "white", width: "800px", margin: "0 auto" }} />
    </div>
  );
};

export default Banner;
